import { ProductKey } from '@/components/signup/utils/products';
import { useIsUpgradeEligible } from '@/components/user-context/helpers/cohorts';
import { useUserContext } from '@/components/user-context/user-context-provider';

import { handleSignupRouteRedirects } from '../utils/signup-redirection-resolver';

import { LoggedInJpd } from './logged-in/logged-in-jpd';
import { LoggedOutJpd } from './logged-out/logged-out-jpd';

export const JpdSignup = () => {
	const {
		user: { isUserLoggedIn },
		edition,
	} = useUserContext();
	const isUpgradeEligible = useIsUpgradeEligible();

	const shouldRedirect = handleSignupRouteRedirects({
		// Hardcoding since we don't need extra check for JPD product
		product: ProductKey.JIRA_PRODUCT_DISCOVERY,
		bundle: 'jira-product-discovery',
		isUpgradeEligible,
		edition,
	});

	if (shouldRedirect) {
		return <></>;
	}

	if (isUserLoggedIn) {
		return <LoggedInJpd />;
	}

	return <LoggedOutJpd />;
};
